import { useState, type FormEvent } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { navSites, siteCategories } from '@/mocks/navigation';

export default function Hero() {
  const navigate = useNavigate();
  const [keyword, setKeyword] = useState('');

  const handleSearch = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const value = keyword.trim();
    navigate(value ? `/?q=${encodeURIComponent(value)}#directory` : '/#directory');
  };

  const stats = [
    { label: '精选站点', value: `${navSites.length}+` },
    { label: '覆盖领域', value: `${siteCategories.length}` },
    { label: '目录更新', value: '每日' },
    { label: '用户收藏', value: '2.4万+' },
  ];

  return (
    <section aria-labelledby="hero-title" className="relative w-full overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Abstract%20editorial%20collage%20of%20layered%20paper%20cards%20and%20glowing%20amber%20light%20trails%20over%20a%20deep%20crimson%20to%20burnt%20orange%20gradient%20background%2C%20stylized%20geometric%20grid%20patterns%2C%20minimal%20modern%20graphic%20design%2C%20soft%20film%20grain%20texture%2C%20high%20contrast%20negative%20space%20for%20overlaying%20text&width=1600&height=900&seq=baoliao-hero-2026&orientation=landscape"
        alt="爆料导航网首屏背景：抽象编辑风卡片与暖色光带"
        title="爆料导航网 - 分类整理网站目录"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/75 via-foreground-950/60 to-foreground-950/80"></div>

      <div className="relative w-full px-4 md:px-6 lg:px-10 pt-28 md:pt-36 pb-14 md:pb-20">
        <div className="w-full animate-fade-up">
          <span className="inline-flex items-center gap-2 rounded-full border border-background-50/25 bg-background-50/10 px-3 py-1 font-label text-xs text-background-50">
            <i className="ri-bookmark-3-line" aria-hidden="true"></i>
            十大领域分类 · 站点目录每日更新
          </span>

          <h2
            id="hero-title"
            className="mt-5 max-w-4xl font-heading text-3xl leading-tight md:text-5xl md:leading-[1.15] font-black text-background-50"
          >
            把散落各处的信息入口，
            <span className="text-accent-300">按领域一次归好类</span>
          </h2>

          <p className="mt-5 max-w-2xl text-sm leading-relaxed md:text-base text-background-50/80">
            爆料导航网把热点、娱乐、财经、科技、消费维权等方向的信息站点集中收录。同类站点排在一起，点开一个分区就能顺着找到更多，不用再自己攒收藏夹。
          </p>

          <form onSubmit={handleSearch} className="mt-7 flex flex-col sm:flex-row items-stretch gap-3 w-full max-w-2xl" role="search">
            <div className="flex flex-1 items-center gap-2 h-12 rounded-full bg-background-50 px-4">
              <span className="w-5 h-5 flex items-center justify-center text-lg text-foreground-500">
                <i className="ri-search-line" aria-hidden="true"></i>
              </span>
              <input
                type="search"
                value={keyword}
                onChange={(event) => setKeyword(event.target.value)}
                placeholder="输入想找的站点名称或领域，例如：汽车质量"
                aria-label="搜索站点名称或领域"
                className="flex-1 bg-transparent text-sm text-foreground-900 outline-none placeholder:text-foreground-400"
              />
            </div>
            <button
              type="submit"
              className="h-12 px-7 rounded-full bg-primary-500 text-background-50 font-label text-sm whitespace-nowrap hover:bg-primary-600 transition-colors"
            >
              开始检索
            </button>
          </form>

          <dl className="mt-10 grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6 max-w-2xl">
            {stats.map((item) => (
              <div key={item.label} className="rounded-lg border border-background-50/15 bg-background-50/5 px-4 py-3">
                <dt className="font-label text-xs text-background-50/65">{item.label}</dt>
                <dd className="mt-1 font-heading text-xl md:text-2xl font-bold text-background-50">{item.value}</dd>
              </div>
            ))}
          </dl>

          <div className="mt-10">
            <p className="font-label text-xs tracking-[0.2em] text-background-50/60">快速进入分类</p>
            <div className="mt-3 flex flex-wrap gap-2">
              {siteCategories.map((category) => (
                <Link
                  key={category.id}
                  to={`/category/${category.id}`}
                  className="inline-flex items-center gap-1.5 rounded-full border border-background-50/25 bg-background-50/10 px-3.5 py-1.5 font-label text-xs text-background-50 whitespace-nowrap hover:bg-background-50/20 transition-colors"
                >
                  <i className={category.icon} aria-hidden="true"></i>
                  {category.name}
                </Link>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}